import React from 'react';
import './LearningStreak.css';
import useIsMobile from '../../hooks/ismobile.js';

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const today = new Date();
const currentDayIndex = (today.getDay() + 6) % 7; // Adjust so Monday = 0

const LearningStreak = ({ streakData }) => {
	// Example: Last 7 days streak (true = studied, false = not)
	//const streakData = [true, true, true, true, false, false, false];
	const currentStreak = streakData.filter((d) => d).length;
	const isMobile = useIsMobile();

	return (
		<div>
			{!isMobile ? (
				<>
					<h2 className="streak-title">Learning Streak</h2>
					<div className="streak-grid">
						{daysOfWeek.map((day, index) => (
							<div key={index} className="streak-day">
								<div className="day-label">{day}</div>
								<div
									className={`day-box ${
										streakData[index] ? 'streak-active' : 'streak-inactive'
									}`}
								></div>
							</div>
						))}
					</div>
					<p className="streak-message">
						🔥 <span className="bold">{currentStreak}-day streak active!</span> Keep it
						going!
					</p>
				</>
			) : (
				<>
					<h2 className="streak-title">Learning Streak</h2>
					<div className="streak-grid-mobile">
						{daysOfWeek.map((day, index) => (
							<div key={index} className="day-row">
								<div className="day-label-mobile">{day.charAt(0)}</div>
								<div
									className={`day-box ${
										streakData[index] ? 'streak-active' : 'streak-inactive'
									}`}
								></div>
							</div>
						))}
					</div>
					<p className="streak-message">
						🔥 <span className="bold">{currentStreak}-day streak active!</span> Keep it
						going!
					</p>
				</>
			)}
		</div>
	);
};

export default LearningStreak;
